export const CASE_ACCEPT = 'CASE_ACCEPT';
export const CASE_REJECT = 'CASE_REJECT';
export const CASE_CANCEL = 'CASE_CANCEL';
export const CANCEL_USER_DELETE = 'CANCEL_USER_DELETE';
export const FIND_LAWYER = 'FIND_LAWYER';
export const CASE_APPROVE_MODAL = 'CASE_APPROVE_MODAL';
export const CASE_REJECT_MODAL = 'CASE_REJECT_MODAL';
export const CASE_REJECT_ATTORNEY_MODAL = 'CASE_REJECT_ATTORNEY_MODAL';
export const CASE_RESUBMIT_MODAL = 'CASE_RESUBMIT_MODAL';

const Modals = (state = {}, action: {
    payload: any,
    type: string
}) => {
    switch (action.type) {
        // Sidebar

        case CASE_ACCEPT:
            return {
                ...state,
                caseReject: false,
                cancelCase: false,
                caseAccept: action.payload
            };
        case CASE_REJECT:
            return {
                ...state,
                caseAccept: false,
                cancelCase: false,
                caseReject: action.payload
            };
        case CASE_CANCEL:
            return {
                ...state,
                caseReject: false,
                caseAccept: false,
                cancelCase: action.payload
            };
        case FIND_LAWYER:
            return {
                ...state,
                canSubmit: action.payload
            };
        case CANCEL_USER_DELETE:
            return {
                ...state,
                userDelete: action.payload
            };
        case CASE_APPROVE_MODAL:
            return {
                ...state,
                caseApproveModal: action.payload
            };
        case CASE_REJECT_MODAL:
            return {
                ...state,
                caseRejectModal: action.payload
            };
        case CASE_REJECT_ATTORNEY_MODAL:
            return {
                ...state,
                caseResubmitModal: false,
                caseRejectAttorneyModal: action.payload
            };
        case CASE_RESUBMIT_MODAL:
            return {
                ...state,
                caseRejectAttorneyModal: false,
                caseResubmitModal: action.payload
            };
        default:
            break;
    }
    return state;
};

export default Modals;
